<template>
	<div class="overlay">
		<v-card>
			<v-card-title>
				<span class="text-h5">{{ $t('planning_restore_duty') }}</span>
			</v-card-title>
			<v-card-text v-if="deletedDuties.length">
				<div class="table-container" @scroll="handleScroll">
					<table>
						<thead>
							<tr>
								<th>{{ $t('duty_duty') }}</th>
								<th>{{ $t('duty_day') }}</th>
								<th>{{ $t('duty_shift') }}</th>
								<th style="min-width: 200px">{{ $t('planning_disposition') }}</th>
								<th style="min-width: 200px">{{ $t('duty_deleted_by') }}</th>
								<th></th>
							</tr>
						</thead>
						<tbody>
							<tr v-for="(duty, index) in deletedDuties" :key="duty.id">
								<td>{{ duty.name }}</td>
								<td>{{ formatDate(duty.day?.date) }}</td>
								<td>{{ secondsToTime(duty.start) + ' - ' + secondsToTime(duty.end) }}</td>
								<td style="min-width: 200px">{{ duty.user && drivers[duty.user] ? drivers[duty.user].displayName : '-' }}</td>
								<td style="min-width: 200px">{{ drivers[duty.deletedBy] ? drivers[duty.deletedBy].displayName : duty.deletedBy }}</td>
								<td>
									<v-btn icon @click="restore(index)" class="mx-2">
										<v-icon color="primary" :title="$t('action_undelete')">mdi-delete-restore</v-icon>
									</v-btn>
								</td>
							</tr>
						</tbody>
					</table>
				</div>
			</v-card-text>
			<v-card-actions class="buttons">
				<v-btn color="primary darken-1" variant="text" @click="$emit('close')">
					{{ $t('action_close') }}
				</v-btn>
				<v-progress-circular size="25" indeterminate color="primary" style="margin-left: calc(50% - 12.5px)" v-if="loading"></v-progress-circular>
			</v-card-actions>
		</v-card>
	</div>
</template>

<script>
import { mapActions, mapState } from 'vuex';
import useDateTime from '../../components/composables/useDateTime';

export default {
	setup() {
		const { formatDate } = useDateTime();
		return { formatDate };
	},
	data() {
		return {
			loading: true,
		};
	},
	computed: {
		...mapState({
			deletedDuties: (state) => state.planning.deletedDuties,
			drivers: (state) => state.planning.driversRef,
			allDeletedDutiesLoaded: (state) => state.planning.allDeletedDutiesLoaded,
			currentChunk: (state) => state.planning.currentChunk,
		}),
	},
	methods: {
		...mapActions({
			loadDeletedDutiesChunk: 'planning/loadDeletedDutiesChunk',
			restoreDuty: 'planning/restoreDuty',
			nextChunk: 'planning/nextChunk',
		}),
		secondsToTime(seconds) {
			if (seconds === null || seconds === undefined) {
				return '';
			}
			const hours = Math.floor(Math.abs(seconds) / 3600);
			const mins = Math.abs(Math.round((Math.abs(seconds) - hours * 3600) / 60));
			let time = hours.toString().padStart(2, '0') + ':' + mins.toString().padStart(2, '0');
			if (seconds < 0) {
				time = '-' + time;
			}
			return time;
		},
		async restore(index) {
			this.loading = true;
			try {
				await this.restoreDuty({ duty: this.deletedDuties[index].id, index });
				if (!this.allDeletedDutiesLoaded) {
					await this.loadDeletedDutiesChunk(this.currentChunk);
				}
			} catch (err) {
				console.log(err);
			}
			this.loading = false;
		},
		async handleScroll(event) {
			if (this.allDeletedDutiesLoaded || this.loading) {
				return;
			}
			if (event.target) {
				const offsetBottom = event.target.scrollHeight - event.target.clientHeight - event.target.scrollTop;
				if (offsetBottom === 0) {
					this.nextChunk();
					this.loading = true;
					await this.loadDeletedDutiesChunk(this.currentChunk);
					this.loading = false;
				}
			}
		},
	},
	async beforeMount() {
		await this.loadDeletedDutiesChunk(0);
		this.loading = false;
	},
};
</script>

<style scoped>
.overlay {
	position: fixed;
	top: 0;
	left: 0;
	width: 100vw;
	height: 100vh;
	display: flex;
	justify-content: center;
	align-items: center;
	background-color: rgba(0, 0, 0, 0.3);
	z-index: 10000;
}

.table-container {
	max-width: 90vw;
	max-height: calc(100vh - 200px);
	overflow-y: scroll;
}

table {
	border-collapse: collapse;
}

th {
	text-align: left;
}

tr > td:not(tr > td:last-of-type),
tr > th:not(tr > th:last-of-type) {
	border-right: 1px solid #aaaaaa;
}

th:not(:last-of-type),
td:not(:last-of-type) {
	padding: 5px 10px;
	min-width: 130px;
	word-wrap: break-word;
}

tbody > tr {
	border-top: 1px solid #eeeeee;
}

thead {
	position: sticky;
	background-color: white;
	box-shadow: inset 0px -1px 0px 0px #eeeeee;
}

thead {
	top: 0;
	z-index: 2;
}

.cell-spacing:not(.cell-spacing:first-of-type) {
	margin-top: 12px;
}

.vertical-align-top td {
	vertical-align: top;
}

.buttons {
	display: flex;
	flex-direction: row-reverse;
	justify-content: space-between;
	align-items: center;
}
</style>
